// extracted by mini-css-extract-plugin
module.exports = {"colHeader":"pageheader_colHeader__fUpEU","leftSide":"pageheader_leftSide__2fUHV","rightSide":"pageheader_rightSide__2AYY5","searchBar":"pageheader_searchBar__1hU2x"};